import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import productReducer from './slices/productSlice';
import cartReducer from './slices/cartSlice';
import wishlistReducer from './slices/wishlistSlice';
import orderReducer from './slices/orderSlice';
import categoryReducer from './slices/categorySlice';
import userReducer from './slices/userSlice';
import couponReducer from './slices/couponSlice';
import heroReducer from './slices/heroSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    orders: orderReducer,
    categories: categoryReducer,
    users: userReducer,
    coupons: couponReducer,
    hero: heroReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});
